import React from 'react';

export type ShopConfigContextProps = Readonly<
  Partial<{
    canonicalUrl: string;
    themeColor: string;
    title: string;
    titleTemplate: string;
    description: string;
    gaTrackingID: string;
    locales: string[];
    defaultLocale: string;
  }>
>;

const defaultShopConfig: ShopConfigContextProps = {
  locales: ['en'],
  defaultLocale: 'en',
};

const ShopConfigContext = React.createContext<ShopConfigContextProps>(defaultShopConfig);

export const { Consumer: ShopConfigContextConsumer } = ShopConfigContext;

interface Props {
  value: ShopConfigContextProps;
}

export const useShopConfig = () => React.useContext(ShopConfigContext);

export const ShopConfigProviderComponent: React.FC<React.PropsWithChildren<Props>> = ({ value, children }) => {
  const mergedValue = value ? { ...defaultShopConfig, ...value } : defaultShopConfig;

  return <ShopConfigContext.Provider value={mergedValue}>{children}</ShopConfigContext.Provider>;
};
export const ShopConfigProvider = React.memo(ShopConfigProviderComponent);

export default ShopConfigContext;
